import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import multiguard from 'vue-router-multiguard'
import { LoginGuard } from '@/guards/login.guard'

// error pages
import PageError401 from '@/pages/errors/401'
import PageNotFound from '@/pages/errors/404'
import PageError500 from '@/pages/errors/500'
import PageError503 from '@/pages/errors/503'

// login pages
import Login from '@/pages/Login'

// password forgot pages
import PasswordForgotStep01Mail from '@/pages/password-forgot/Step01Mail'
import PasswordForgotStep02Code from '@/pages/password-forgot/Step02Code'
import PasswordForgotStep03Reset from '@/pages/password-forgot/Step03Reset'
import PasswordForgotStep04Complete from '@/pages/password-forgot/Step04Complete'

// member register pages
import AccountCreateStep01Mail from '@/pages/account-create/Step01Mail'
import AccountCreateStep02Code from '@/pages/account-create/Step02Code'
import AccountCreateStep03Form from '@/pages/account-create/Step03Form'
import AccountCreateStep04Confirm from '@/pages/account-create/Step04Confirm'
import AccountCreateStep05Complete from '@/pages/account-create/Step05Complete'

// member edit pages
import AccountEditStep01Form from '@/pages/account-edit/Step01Form'
import AccountEditStep02Confirm from '@/pages/account-edit/Step02Confirm'
import AccountEditStep03Complete from '@/pages/account-edit/Step03Complete'

// member mail change pages
import MailChangeStep01Mail from '@/pages/mail-change/Step01Mail'
import MailChangeStep02Code from '@/pages/mail-change/Step02Code'

// member password change pages
import PasswordChangeStep01Form from '@/pages/password-change/Step01Form'

// member withdrawal pages
import WithdrawalStep01Confirm from '@/pages/withdrawal/Step01Confirm'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // login pages
    {
      path: '/ec/login',
      name: 'Login',
      component: Login,
      meta: {
        pageTitle: {
          value: '',
          type: false
        },
        sideNavType: false,
        sideNavNone: true,
        headerType: 1
      }
    },

    // password forgot pages
    {
      path: '/ec/password-forgot',
      name: 'PasswordForgot',
      component: PasswordForgotStep01Mail,
      meta: {
        pageTitle: {
          value: 'パスワードを忘れた方',
          type: true
        },
        sideNavType: true,
        sideNavNone: false,
        headerType: 1
      }
    },
    {
      path: '/ec/password-forgot/code/:id',
      name: 'PasswordForgotCode',
      component: PasswordForgotStep02Code,
      meta: {
        pageTitle: {
          value: 'パスワードリセット',
          type: true
        },
        sideNavType: false,
        sideNavNone: true,
        headerType: 1
      }
    },
    {
      path: '/ec/password-forgot/reset',
      name: 'PasswordForgotStep03Reset',
      component: PasswordForgotStep03Reset,
      meta: {
        pageTitle: {
          value: 'パスワードリセット',
          type: true
        },
        sideNavType: false,
        sideNavNone: true,
        headerType: 1
      }
    },
    {
      path: '/ec/password-forgot/complete',
      name: 'PasswordForgotStep04Complete',
      component: PasswordForgotStep04Complete,
      meta: {
        pageTitle: {
          value: 'パスワードリセット完了',
          type: true
        },
        sideNavType: false,
        sideNavNone: true,
        headerType: 1
      }
    },

    // member register pages
    {
      path: '/ec/account-create',
      name: 'AccountCreateStep01Mail',
      component: AccountCreateStep01Mail,
      meta: {
        pageTitle: {
          value: 'メールアドレス認証',
          type: true
        },
        sideNavType: true,
        headerType: 1
      }
    },
    {
      path: '/ec/account-create/code/:id',
      name: 'AccountCreateStep02Code',
      component: AccountCreateStep02Code,
      meta: {
        pageTitle: {
          value: 'メールアドレス認証',
          type: true
        },
        sideNavType: true,
        headerType: 1
      }
    },
    {
      path: '/ec/account-create/register',
      name: 'AccountCreateStep03Form',
      component: AccountCreateStep03Form,
      meta: {
        pageTitle: {
          value: 'アカウント登録',
          type: true
        },
        sideNavType: true,
        headerType: 1
      }
    },
    {
      path: '/ec/account-create/confirm',
      name: 'AccountCreateStep04Confirm',
      component: AccountCreateStep04Confirm,
      meta: {
        pageTitle: {
          value: 'アカウント登録',
          type: true
        },
        sideNavType: true,
        headerType: 1
      }
    },
    {
      path: '/ec/account-create/complete',
      name: 'AccountCreateStep05Complete',
      component: AccountCreateStep05Complete,
      meta: {
        pageTitle: {
          value: 'アカウント登録',
          type: true
        },
        sideNavType: false,
        sideNavNone: true,
        headerType: 1
      }
    },

    // member edit pages
    {
      path: '/ec/account-edit',
      name: 'AccountEditStep01Form',
      component: AccountEditStep01Form,
      meta: {
        pageTitle: {
          value: 'アカウント編集',
          type: true
        },
        sideNavType: true,
        headerType: 1
      },
      beforeEnter: multiguard([LoginGuard])
    },
    {
      path: '/ec/account-edit/confirm',
      name: 'AccountEditStep02Confirm',
      component: AccountEditStep02Confirm,
      meta: {
        pageTitle: {
          value: 'アカウント編集',
          type: true
        },
        sideNavType: true,
        headerType: 1
      },
      beforeEnter: multiguard([LoginGuard])
    },
    {
      path: '/ec/account-edit/complete',
      name: 'AccountEditStep03Complete',
      component: AccountEditStep03Complete,
      meta: {
        pageTitle: {
          value: 'アカウント編集',
          type: true
        },
        sideNavType: false,
        sideNavNone: true,
        headerType: 1
      },
      beforeEnter: multiguard([LoginGuard])
    },

    // member mail change pages
    {
      path: '/ec/mail-change',
      name: 'MailChangeStep01Mail',
      component: MailChangeStep01Mail,
      meta: {
        pageTitle: {
          value: 'メールアドレス変更',
          type: true
        },
        sideNavType: true,
        headerType: 1
      },
      beforeEnter: multiguard([LoginGuard])
    },
    {
      path: '/ec/mail-change/code/:id',
      name: 'MailChangeStep02Code',
      component: MailChangeStep02Code,
      meta: {
        pageTitle: {
          value: 'メールアドレス変更',
          type: true
        },
        sideNavType: true,
        headerType: 1
      },
      beforeEnter: multiguard([LoginGuard])
    },

    // member password change pages
    {
      path: '/ec/password-change',
      name: 'PasswordChangeStep01Form',
      component: PasswordChangeStep01Form,
      meta: {
        pageTitle: {
          value: 'パスワード変更',
          type: true
        },
        sideNavType: true,
        headerType: 1
      },
      beforeEnter: multiguard([LoginGuard])
    },

    // member withdrawal pages
    {
      path: '/ec/withdrawal-confirm',
      name: 'WithdrawalStep01Confirm',
      component: WithdrawalStep01Confirm,
      meta: {
        pageTitle: {
          value: '退会',
          type: true
        },
        sideNavType: true,
        headerType: 1
      },
      beforeEnter: multiguard([LoginGuard])
    },

    // error pages
    {
      path: '/ec/errors/401',
      name: 'Error401',
      component: PageError401,
      meta: {
        pageTitle: {
          value: '401 Unauthorized',
          type: false
        },
        sideNavType: false,
        headerType: 1
      }
    },
    {
      path: '/ec/errors/500',
      name: 'Error500',
      component: PageError500,
      meta: {
        pageTitle: {
          value: '500 Internal Server Error',
          type: false
        },
        sideNavType: false,
        headerType: 1
      }
    },
    {
      path: '/ec/errors/503',
      name: 'Error503',
      component: PageError503,
      meta: {
        pageTitle: {
          value: '503 Service Unavailable',
          type: false
        },
        sideNavType: false,
        headerType: 1
      }
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound,
      meta: {
        pageTitle: {
          value: '404 Not Found',
          type: false
        },
        sideNavType: false,
        headerType: 1
      }
    }
  ]
})
router.beforeEach((to, from, next) => {
  // SET LOADING
  store.commit('loadingAction', true)

  // Back to Top - Before changing page
  window.scrollTo(0, 0)

  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js